import type { BoxProps } from '@hover/blueprint';
import {
  Body,
  Box,
  Image,
  Logo,
  Divider as SystemDivider,
} from '@hover/blueprint';
import React from 'react';

import { DesignerPartner } from '../../constants/partners';
import { usePartnerCobranding } from '../../hooks/usePartner';

export enum LOGO_FILTER {
  TEXT = 'text',
  TRANSPARENT = 'transparent',
  PILL = 'pill',
}

interface CobrandLogoProps extends BoxProps {
  hideHoverMark?: boolean;
  colorMode?: 'light' | 'dark';
  height?: number;
}

export const CobrandLogo = ({
  hideHoverMark,
  colorMode = 'light',
  height = 200,
  ...props
}: CobrandLogoProps) => {
  const cobranding = usePartnerCobranding();
  const cobrandName = cobranding?.displayName;
  const cobrandLogo =
    (colorMode === 'light' ? cobranding?.logoUrl : cobranding?.logoUrlInvert) ??
    undefined;
  let filter =
    cobranding?.partner === DesignerPartner.NONE
      ? LOGO_FILTER.PILL
      : LOGO_FILTER.TRANSPARENT;

  if (!cobrandLogo) {
    filter = LOGO_FILTER.TEXT;
  }

  return (
    <Box
      alignItems="center"
      height="100%"
      justifyContent="flex-start"
      zIndex={1}
      {...props}
    >
      <Logo
        colorMode={colorMode}
        display={hideHoverMark ? 'none' : 'block'}
        height={height}
        variant="symbol"
      />
      {(cobrandName || cobrandLogo) && !hideHoverMark && (
        <SystemDivider
          borderBottomWidth={0}
          borderColor="neutral.200"
          borderLeftWidth="1px"
          height="22px"
          margin="0"
          mx={200}
          width={0}
        />
      )}
      {filter === LOGO_FILTER.TEXT && (
        <Body
          color={colorMode === 'dark' ? 'neutral.100' : 'neutral.900'}
          margin="0 !important"
        >
          {cobrandName}
        </Body>
      )}
      {filter === LOGO_FILTER.TRANSPARENT && (
        <Image alt="cobrand logo" height={height} src={cobrandLogo} />
      )}
      {filter === LOGO_FILTER.PILL && (
        <Box
          backgroundColor="neutral.100"
          borderRadius={200}
          height={200}
          justifyContent="center"
          ml={100}
          objectFit="cover"
          p={100}
        >
          <Image
            alt="cobrand logo"
            display="block"
            height="100%"
            src={cobrandLogo}
            width="auto"
          />
        </Box>
      )}
    </Box>
  );
};
